export default function BenefitsSection() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Проверенные таблицы',
      desc: 'Все Yoybuy Spreadsheet проходят ручную проверку качества перед публикацией. Мы гарантируем актуальность и достоверность данных.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Быстрый поиск товаров',
      desc: 'Находите лучшие товары на Taobao, Weidian и 1688 за считанные минуты с помощью готовых таблиц.',
    },
    {
      icon: 'ri-global-line',
      title: 'Доставка в Россию',
      desc: 'Проверенные маршруты доставки из Китая в Россию. Безопасно, надёжно и с полным отслеживанием.',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Детальные описания',
      desc: 'Каждый товар в таблице содержит подробное описание, QC-фото, размерную сетку и рекомендации.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Регулярные обновления',
      desc: 'Таблицы обновляются еженедельно. Вы всегда получаете актуальные ссылки и цены.',
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Поддержка 24/7',
      desc: 'Наша команда всегда готова помочь с выбором товаров и ответить на любые вопросы.',
    },
  ];

  return (
    <section id="why-choose" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            Преимущества
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Почему выбирают Yoybuy Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Тысячи покупателей из России уже доверяют нашим таблицам для безопасных покупок из Китая
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {benefits.map((b, idx) => (
            <div
              key={idx}
              className="flex flex-col gap-4 p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${b.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">{b.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}